<div class="mb-3">
  <div class="row">

  <!-- #94: /search with an emptied field is the landing page again — the personalized strips
       come back the moment the search is cleared, and disappear while one is active. At `/`
       the same component is mounted by the app shell instead (there is no '' route), so the
       two mount points are mutually exclusive. -->
  @if (!filter.isSearchActive) {
    <div class="row">
      <app-landing-page></app-landing-page>
    </div>
  }

  @if (filter.isSearchActive) {
    <div>
      @if (catalogItems?.length > 0) {
        <h1 class="pb-2 border-bottom fw-light" i18n>Ergebnisse</h1>
      } @else {
        <h1 class="pb-2 border-bottom fw-light" i18n>Keine Ergebnisse vorhanden</h1>
      }

      <!-- #172: the radius belongs to the result, not to the input, so it sits here rather than
           in the search bar — and in the empty state too, because a radius is what empties a
           list most often and widening it is the way out. The chips wait for a position: without
           one there is nothing to measure from, and the list below is the plain search. -->
      <div class="search-radius-bar d-flex flex-wrap align-items-center gap-2 mt-3" data-testid="search-radius-bar">
        <span class="text-muted" i18n="@@search.radius.label">Umkreis:</span>
        <div class="btn-group btn-group-sm" role="group" i18n-aria-label="@@search.radius.label" aria-label="Umkreis:">
          @for (option of radiusOptions; track option) {
            <button
              type="button"
              class="btn"
              [class.btn-primary]="radiusKm === option"
              [class.btn-outline-secondary]="radiusKm !== option"
              [attr.aria-pressed]="radiusKm === option"
              [disabled]="!location"
              (click)="setRadius(option)"
              [attr.data-testid]="'search-radius-' + option"
            >
              {{ option }} km
            </button>
          }
          <button
            type="button"
            class="btn"
            [class.btn-primary]="radiusKm === null"
            [class.btn-outline-secondary]="radiusKm !== null"
            [attr.aria-pressed]="radiusKm === null"
            [disabled]="!location"
            (click)="setRadius(null)"
            data-testid="search-radius-any"
            i18n="@@search.radius.any"
          >
            egal
          </button>
        </div>
        @if (location) {
          <span class="text-muted small d-inline-flex align-items-center" data-testid="search-location-label">
            <fa-icon [icon]="faMapMarkerAlt" class="me-1"></fa-icon>
            {{ location.label }}
          </span>
        }
      </div>

      <!-- State C of the mockup, without the map yet: the offer to locate the search, never a
           prompt and never an empty list — the results below are complete and unfiltered. -->
      @if (!location) {
        <div class="search-no-location card card-body mt-3" data-testid="search-no-location">
          <p class="mb-2" i18n="@@search.noLocation.text">
            Um Angebote in Ihrer Nähe zu sehen, brauchen wir Ihren Standort. Bis dahin zeigt die Liste alle Treffer.
          </p>
          <app-location-picker></app-location-picker>
        </div>
      }

      <!-- #172: the map block, expanded by default on wide viewports; the list below stays the
           full-value view. -->
      @if (mapQuery) {
        <app-catalog-map class="d-block mt-3" [query]="mapQuery" (sellerSelected)="selectSeller($event)"></app-catalog-map>
      }

      @if (selectedSeller) {
        <div class="search-seller-filter d-inline-flex align-items-center gap-2 mt-3 px-3 py-2 rounded border bg-light" data-testid="search-seller-filter">
          <span i18n="@@search.sellerFilter.label">Nur Anbieter: {{ selectedSeller.name }}</span>
          <button type="button" class="btn btn-link btn-sm p-0" (click)="clearSeller()" data-testid="search-seller-filter-clear" i18n="@@search.sellerFilter.clear">
            Alle anzeigen
          </button>
        </div>
      }

      @if (catalogItems?.length > 0) {
        <div class="catalog-item-grid mt-4">
          @for (catalogItem of visibleItems; track catalogItem) {
            @if (catalogItem.catalogSku) {
              <app-catalog-item-card
                [catalogSku]="catalogItem.catalogSku"
                [distanceLabel]="catalogItem.catalogSku.distanceKm | distance"
                [isBookmarked]="bookmarkedIds.has(catalogItem.catalogSku.skuId)"
                [bookmarkAction]="canBookmark ? bookmarkAction(catalogItem.catalogSku.skuId) : null"
              ></app-catalog-item-card>
            }
          }
        </div>
        @if (selectedSeller) {
          <p class="text-muted mt-3" data-testid="search-seller-filter-count" i18n="@@search.sellerFilter.count">
            {{ visibleItems.length }} der {{ catalogItems.length }} geladenen Einträge sind von {{ selectedSeller.name }} ({{ totalCount }} insgesamt)
          </p>
        } @else {
          <p class="text-muted mt-3" i18n="@@pagedList.countOfTotal">{{ catalogItems.length }} von {{ totalCount }} Einträgen</p>
        }
        @if (catalogItems.length < totalCount) {
          <button class="btn btn-outline-primary" type="button" (click)="loadMore()" [disabled]="loadingMore" i18n="@@pagedList.loadMore">
            @if (loadingMore) {
              <span class="spinner-border spinner-border-sm me-1"></span>
            }
            Mehr laden
          </button>
        }
      } @else if (isLocated) {
        <p class="text-muted mt-3" data-testid="search-no-results-in-radius" i18n="@@search.noResultsInRadius">
          Im Umkreis von {{ radiusKm }} km um {{ location.label }} gibt es keine Treffer. Vergrößern Sie den Umkreis oder wählen Sie „egal“.
        </p>
      }
    </div>
  }
</div>
</div>
